export default function Footer() {
  return (
    <>
      <footer id="footer-4" className="footer division">
        <div className="container grey-color">
          <div className="bottom-footer">
            <div className="row d-flex align-items-center">
              <div className="col-md-5 col-lg-6">
                <div className="footer-copyright">
                  <p>
                    © 2025 <a href="https://www.kuberpos.com">Kuber POS.</a> All
                    Rights Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
